import template from './notification_management.html';
import controller from './notification_management.controller';
import './notification_management.scss';

let NotificationManagementComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default NotificationManagementComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/notification_management.component.js